<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form [formGroup]="editgpsTypeForm" class="admin-forms">
  <div class="accordion-class">
    <h5>Edit GPS Type</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group">
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Server Name:</mat-label>
          <input
            matInput
            formControlName="server_name"
            style="text-transform: capitalize"
            required
          />
          <mat-error
            *ngIf="(GpsTypeFormControl['server_name'].touched) && GpsTypeFormControl['server_name'].errors?.['required']"
          >
            Please Enter Server Name
          </mat-error>
          <mat-error
            *ngIf="(GpsTypeFormControl['server_name'].touched) && GpsTypeFormControl['server_name'].errors?.['pattern']"
          >
            Please Enter Valid Server Name
          </mat-error>
        </mat-form-field>
      </div>
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Server Url:</mat-label>
          <input matInput formControlName="server_url" required />
          <mat-error
            *ngIf="(GpsTypeFormControl['server_url'].touched) && GpsTypeFormControl['server_url'].errors?.['required']"
            >Please Enter Server URL</mat-error
          >
        </mat-form-field>
      </div>
      <div class="mb-3 pull-left w-100">
        <mat-form-field>
          <mat-label>Server Token</mat-label>
          <input matInput  type="password" formControlName="server_token" required />
          <mat-error
            *ngIf="(GpsTypeFormControl['server_token'].touched) && GpsTypeFormControl['server_token'].errors?.['required']"
            >Please Enter Server Token</mat-error
          >
        
        </mat-form-field>
      </div>
    </div>
  </div>
  <button
    [class.spinner]="loading"
    [disabled]="loading"
    type="button"
    class="button buttonBlue"
    (click)="UpdateGps()"
  >
    Submit
  </button>
</form>
